var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as pc from "playcanvas";
import { createElement } from "react";
import { render } from "react-dom";
import { Http } from "@animech/platform/utilities/http";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { BuildInfo } from "utility/buildinfo";
import { App } from "ui/app";
import i18n from "i18n/setup";
import { client } from "api/ovm-backend/client.gen";
import { setTactonApiLanguage } from "api/tacton/common-api";
import { getQualitySettings, installEmbedTelemetry, isEmbedMode } from "embed";
// IMPORTANT: It's very important that this is done as early in the app setup as possible.
// This will override the default baseUrl (http://localhost:7071) used by the auto generated ovm-backend client.
client.setConfig({
    baseUrl: process.env.OVM_BACKEND_BASE_URL,
});
Sentry.init({
    dsn: process.env.SENTRY_DSN,
    integrations: [new BrowserTracing()],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    environment: process.env.SENTRY_ENVIRONMENT,
});
var config = {
    domRoot: "app-root",
    configUrl: "appconfig.json",
};
var Bootstrapper = /** @class */ (function () {
    function Bootstrapper() {
    }
    Bootstrapper.prototype.start = function () {
        var _a, _b;
        return __awaiter(this, void 0, Promise, function () {
            var query, queryParams, storedLanguage, urlLanguage, language;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        /* ChatGPT embed (CONTRACT-piab.md §7): lifecycle telemetry to the parent shell, embed mode only. */
                        if (isEmbedMode()) {
                            installEmbedTelemetry({ quality: getQualitySettings().level });
                        }
                        if (BuildInfo.mode !== "production") {
                            // eslint-disable-next-line no-console
                            console.log("Running version ".concat(BuildInfo.version, " in ").concat(BuildInfo.mode, " mode"));
                        }
                        query = window.location.hash.split("?")[1];
                        queryParams = new URLSearchParams(query);
                        storedLanguage = (_a = localStorage.getItem("piab-language")) !== null && _a !== void 0 ? _a : "";
                        urlLanguage = (_b = queryParams.get("lang")) !== null && _b !== void 0 ? _b : "";
                        language = i18n.languages.includes(urlLanguage)
                            ? urlLanguage
                            : i18n.languages.includes(storedLanguage)
                                ? storedLanguage
                                : "";
                        if (language) {
                            i18n.changeLanguage(language);
                            setTactonApiLanguage(language);
                        }
                        if (window.electron) {
                            // eslint-disable-next-line no-console
                            console.log("Running app in Electron", window.electron);
                        }
                        // Initialize loading of ammo.js
                        // Used for detecting collisions and triggering collision events.
                        return [4 /*yield*/, new Promise(function (resolve, reject) {
                                pc.WasmModule.setConfig("Ammo", {
                                    glueUrl: "playcanvas/files/assets/164453157/1/ammo.wasm.js",
                                    wasmUrl: "playcanvas/files/assets/164453158/1/ammo.wasm.wasm",
                                    fallbackUrl: "playcanvas/files/assets/164453156/1/ammo.js",
                                    errorHandler: function (error) {
                                        reject(error);
                                    },
                                });
                                pc.WasmModule.getInstance("Ammo", function () {
                                    resolve();
                                });
                            })];
                    case 1:
                        // Initialize loading of ammo.js
                        // Used for detecting collisions and triggering collision events.
                        _c.sent();
                        this._render();
                        return [2 /*return*/];
                }
            });
        });
    };
    Bootstrapper.prototype._render = function () {
        render(createElement(App), document.getElementById(config.domRoot));
    };
    Bootstrapper.prototype._getAppConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _b = (_a = JSON).parse;
                        return [4 /*yield*/, Http.get(config.configUrl)];
                    case 1: return [2 /*return*/, _b.apply(_a, [_c.sent()])];
                }
            });
        });
    };
    return Bootstrapper;
}());
export { Bootstrapper };
